import React, { useState } from 'react';
import { connect } from 'react-redux';
import mapper from './contextMenuMapper';
import * as StyledContextMenu from './contextMenus.styles';
import { closeContextMenu } from '../../actions/contextMenuActions';
import sleep from '../../helpers/sleep';

const ContextMenus = ({
	contextMenuReducer,
	dispatch
}) => {
	const [closing, setIsClosing] = useState(false);
	const { x, y, active } = contextMenuReducer;
	const ContextMenu = mapper[active];
	if(!ContextMenu) return null;

	const close = async () => {
		if(!ContextMenu) return;
		setIsClosing(true);
		await sleep(250);
		dispatch(closeContextMenu());
		setIsClosing(false);
	};

	return (
		<>
			<StyledContextMenu.Overlay onClick={close} closing={closing} />
			<StyledContextMenu.Wrapper x={x} y={y} closing={closing}>
				<ContextMenu />
			</StyledContextMenu.Wrapper>
		</>
	);
};

const mapDispatchToProps = ({ contextMenuReducer }) => ({
	contextMenuReducer
});

export default connect(mapDispatchToProps)(ContextMenus);
